import React from "react";
import { Leaf } from "lucide-react";

// Only these stages get a row in the timeline. The rest (triage, personaSafety,
// finalize) are too quick or too internal to be worth surfacing.
const VISIBLE_STAGES = new Set(["retrieval", "intentPlan", "generation", "critique"]);

export function ChatThinkingTimeline({ stages, hasTokens }) {
  const visible = (stages || []).filter((s) => VISIBLE_STAGES.has(s.name));
  if (visible.length === 0) return <BareThinking />;

  return (
    <div
      className={`ml-4 space-y-3 transition-opacity duration-500 ${
        hasTokens ? "opacity-40" : "opacity-100"
      }`}
    >
      <style>{`
        @keyframes leafBreath {
          0%, 100% { opacity: 0.35; filter: drop-shadow(0 0 3px rgba(74,222,128,0.2)); transform: scale(0.95); }
          50% { opacity: 1; filter: drop-shadow(0 0 14px rgba(74,222,128,0.75)); transform: scale(1.12); }
        }
      `}</style>
      {visible.map((stage) => (
        <StageRow key={stage.name} stage={stage} />
      ))}
    </div>
  );
}

function StageRow({ stage }) {
  const isRunning = stage.status === "running";
  const isDone = stage.status === "done";
  const isSkipped = stage.status === "skipped";
  const isError = stage.status === "error";

  return (
    <div className="flex items-start gap-3 animate-in fade-in slide-in-from-bottom-1 duration-500">
      <Marker isRunning={isRunning} isDone={isDone} isSkipped={isSkipped} isError={isError} />
      <div className="flex-1 -mt-0.5">
        <p
          className={`font-serif italic text-sm ${
            isRunning ? "text-stone-700" : "text-stone-400"
          }`}
        >
          {stage.label || stage.name}
        </p>
        {(isDone || isSkipped) && stage.summary && (
          <p className="text-stone-400 font-sans text-[11px] mt-0.5">{stage.summary}</p>
        )}
        {isError && (
          <p className="text-stone-400 font-sans text-[11px] mt-0.5">
            {stage.error || "couldn't finish — moving on"}
          </p>
        )}
      </div>
    </div>
  );
}

function Marker({ isRunning, isDone, isSkipped, isError }) {
  if (isRunning) {
    return (
      <Leaf
        size={14}
        className="text-emerald-400 mt-0.5"
        style={{ animation: "leafBreath 2.4s ease-in-out infinite" }}
      />
    );
  }
  if (isDone) return <div className="h-2 w-2 rounded-full bg-stone-400 mt-1.5" />;
  if (isSkipped) return <div className="h-2 w-2 rounded-full bg-stone-200 mt-1.5" />;
  if (isError) return <div className="h-2 w-2 rounded-full bg-stone-300 mt-1.5" />;
  return <div className="h-2 w-2 rounded-full border border-stone-300 mt-1.5" />;
}

function BareThinking() {
  return (
    <div className="ml-4 flex items-center gap-3">
      <style>{`
        @keyframes leafBreath {
          0%, 100% { opacity: 0.35; transform: scale(0.95); }
          50% { opacity: 1; transform: scale(1.12); }
        }
      `}</style>
      <Leaf
        size={18}
        className="text-emerald-400"
        style={{ animation: "leafBreath 2.4s ease-in-out infinite" }}
      />
      <span className="text-stone-400 font-serif italic text-sm">Listening…</span>
    </div>
  );
}
